import { useAtom } from 'jotai';
import React from 'react';
import Turnstile, { useTurnstile } from "react-turnstile";
import { isHumanVerifiedAtom } from 'showMessageMenuAtom';
import styles from './TurnstileWidget.module.scss';
import { AuthorizeService } from 'api/services/authorize';

const TurnstileWidget = (
    {
        group,
        widgetBodyStyles,
        widgetpTgaStyles,
        widgetpTgaStylesRequired,
        design,
    }: {
        group?: any,
        widgetBodyStyles?: string,
        widgetpTgaStyles?: string,
        widgetpTgaStylesRequired?: string
        design?: any
    }
) => {
    const isCustomDomain = group && group.custom_domain && group.custom_domain_status === "active";
    const CUSTOMDOMAIN_TURNSTILE_SITE_KEY = group && group.ex_config && group.ex_config.turnstile;

    const TURNSTILE_SITE_KEY = isCustomDomain ? CUSTOMDOMAIN_TURNSTILE_SITE_KEY : String(process.env.REACT_APP_TURNSTILE_SITE_KEY);

    const turnstile = useTurnstile();
    const [, setisHumanVerified] = useAtom(isHumanVerifiedAtom) as any;

    const confrim = (token: string) => {
        if (group && group.id) {
            AuthorizeService.getInstance()
                .confirmYouAreHumanOnCommunity(group.id, token)
                .then((res: any) => {
                    if (res && res.data) {
                        setisHumanVerified({
                            isVerified: true,
                            session_token: res.data.session_token
                        });
                    }
                }).catch((error: any) => {
                    console.error(error)
                    new Error(error)
                    setisHumanVerified({
                        isVerified: false,
                        session_token: undefined
                    });
                    turnstile && turnstile.reset();
                })
        } else {
            AuthorizeService.getInstance()
                .confirmYouAreHuman(token)
                .then((res: any) => {
                    if (res && res.data) {
                        setisHumanVerified({
                            isVerified: true,
                            session_token: res.data.session_token
                        });
                    }
                }).catch((error: any) => {
                    console.error(error)
                    new Error(error)
                    setisHumanVerified({
                        isVerified: false,
                        session_token: undefined
                    });
                    turnstile && turnstile.reset();
                })
        }
    }

    if (window.location.pathname === '/plan-subscription-preview') return null;

    if (isCustomDomain && (!CUSTOMDOMAIN_TURNSTILE_SITE_KEY || CUSTOMDOMAIN_TURNSTILE_SITE_KEY === undefined)) return null;

    const isPurchasePage = window.location.pathname.split("/").pop() === "purchase"
    const isPlanPage = window.location.pathname.split("/")[1] === "plan-subscription"


    const turnstileLandingWidgetStylesP = design ? {
        color: design.field_input_label_color,
        fontFamily: design.field_input_label_font_family,
        fontSize: `${design.field_input_label_font_size}px`,
        lineHeight: `${design.field_input_label_line_height}px`,
    } : {};

    const turnstileLandingWidgetStylesRequired = design ? {
        color: design.field_input_required_color,
    } : {};

    return (
        <div
            id="cloudflaire-turnstile-widget"
            className={`${styles.TurnstileWidget} ${widgetBodyStyles ? widgetBodyStyles : ''}
                ${window.location.pathname === '/signin'
                    ?
                    styles.TurnstileWidget__signin
                    :
                    isPlanPage
                        ?
                        styles.TurnstileWidget__plan
                        :
                        (window.location.pathname === '/forgot-password' || isPurchasePage)
                            ?
                            styles.TurnstileWidget__forgot
                            :
                            ''
                }`}
        >
            <span
                style={{ ...turnstileLandingWidgetStylesP }}
                className={`${widgetpTgaStyles ? widgetpTgaStyles : styles.TurnstileWidget__p}`}
            >
                Let us know you're human
                <span
                    style={{ ...turnstileLandingWidgetStylesRequired }}
                    className={`${widgetpTgaStylesRequired ? widgetpTgaStylesRequired : styles.TurnstileWidget__required}`}
                >
                    *
                </span>
            </span>
            <Turnstile
                id="turnstile-widget"
                sitekey={TURNSTILE_SITE_KEY}
                onVerify={(token: string) => {
                    confrim(token);
                }}
                refreshExpired='auto'
                className={styles.TurnstileWidget__widget}
                size='flexible'
                theme='light'
            />
        </div>
    )
}

export default TurnstileWidget;